import { GET_EQUIPMENT_BY_ID, KEY } from '../../Graphql/QUERIES';
import { Typography, Link } from '@material-ui/core';
import { useEffect } from 'react';
import BottomBar from '../../components/BottomBar';
import PageContainer from '../../components/PageContainer';
import TopBar from '../../components/TopBar';
import { useTheme } from '../../hooks/useTheme';
import { useStyles } from './styles';
import { useQuery } from '@apollo/client';
import { useParams } from 'react-router';
import wave0 from '../../assets/wave2.png';
import wave1 from '../../assets/wave-social.png';
import wave2 from '../../assets/wave-health.png';
import wave3 from '../../assets/wave-leizure.png';
import wave4 from '../../assets/wave-culture.png';
import wave5 from '../../assets/wave-education.png';

function Equipment() {
  const { changeTheme } = useTheme();
  const classes = useStyles();
  const { redeId, equipmentId } = useParams();

  const { loading, error, data } = useQuery(GET_EQUIPMENT_BY_ID, {
    variables: { token: KEY, Id: parseInt(equipmentId) }
  })

  const waves = [wave1, wave2, wave3, wave4, wave5];

  const setWaveColor = (redeId) => {
    if (waves[redeId - 1] === undefined) return wave0;
    return waves[redeId - 1]
  }

  const accessText = (type) => {
    switch(type) {
      case "Direto":
        return "O acesso a esse equipamento é livre"
      case "Privado":
        return"O acesso a esse equipamento é privado"
      default:
        return `Para acessar esse equipamento, é necessário antes passar por um ${data.EquipamentoByID[0].ACESSO}`
    }
  }

  useEffect(() => {
    changeTheme(redeId);
  }, [])

  if (loading) return(
    <>
      <TopBar>
        <Typography variant="h1">
          Carregando...
        </Typography>
      </TopBar>
      <PageContainer>
        <div className={classes.wrapper}>
          <Typography>
            Carregando...
          </Typography>
        </div>
      </PageContainer>
      <BottomBar/>
    </>
  );
  if (error) return(
    <>
      <TopBar>
        <Typography variant="h1">
          Erro
        </Typography>
      </TopBar>
      <PageContainer>
        <div className={classes.wrapper}>
          <Typography>
            Ops! Parece que ocorreu um erro.
            Tente novamente mais tarde.
          </Typography>
        </div>
      </PageContainer>
      <BottomBar/>
    </>
  )

  return (
    <>
      <TopBar>
        <Typography variant="h1">
          {data.EquipamentoByID[0].TipoRedeNome}
        </Typography>
      </TopBar>
      <PageContainer>
        <div className={classes.wrapper}>
          <Typography 
            variant="h2" 
            color="textPrimary" 
            className={classes.title}
          >
            {data.EquipamentoByID[0].Nome}
          </Typography>

          {data.EquipamentoByID[0].TipoEquipamentoNome && (
            <div className={classes.section}>
              <Typography
                className={classes.subtitle}
                color={"primary"}
              >
                Tipo de Equipamento
              </Typography>
              <Typography color="textPrimary" >
                {data.EquipamentoByID[0].TipoEquipamentoNome}
              </Typography>
            </div>
          )}

          {data.EquipamentoByID[0].ACESSO && (
            <div className={classes.section}>
              <Typography
                className={classes.subtitle}
                color={"primary"}
              >
                Tipo de acesso
              </Typography>
              <Typography color="textPrimary" >
                {accessText(data.EquipamentoByID[0].ACESSO)}
              </Typography>
            </div>
          )}

          <div className={classes.section}>
            <Typography
              className={classes.subtitle}
              color={"primary"}
            >
              Descrição
            </Typography>
            <Typography color="textPrimary" >
              {data.EquipamentoByID[0].Descricao}
            </Typography>
          </div>

          {data.EquipamentoByID[0].NATUREZA_JURIDICA && (
            <div className={classes.section}>
              <Typography
                className={classes.subtitle}
                color={"primary"}
              >
                Natureza Jurídica
              </Typography>
              <Typography color="textPrimary" >
                {data.EquipamentoByID[0].NATUREZA_JURIDICA}
              </Typography>
            </div>
          )}

          {data.EquipamentoByID[0].HORARIO && (
            <div className={classes.section}>
              <Typography
                className={classes.subtitle}
                color={"primary"}
              >
                Horário de atendimento
              </Typography>
              <Typography color="textPrimary" >
                {data.EquipamentoByID[0].HORARIO}
              </Typography>
            </div>
          )}

          {data.EquipamentoByID[0].Telefone && (
            <div className={classes.section}>
              <Typography
                className={classes.subtitle}
                color={"primary"}
              >
                Telefone
              </Typography>
              <Typography color="textPrimary" >
                {data.EquipamentoByID[0].Telefone}
              </Typography>
            </div>
          )}

          {data.EquipamentoByID[0].CELULAR && (
            <div className={classes.section}>
              <Typography
                className={classes.subtitle}
                color={"primary"}
              >
                Celular
              </Typography>
              <Typography color="textPrimary" >
                {data.EquipamentoByID[0].CELULAR}
              </Typography>
            </div>
          )}

          {data.EquipamentoByID[0].URL && (
            <>
              <div className={classes.section}>
                <Typography
                  className={classes.subtitle}
                  color={"primary"}
                >
                  Site
                </Typography>
                <Typography>
                  <Link href={data.EquipamentoByID[0].URL} target="_blank" rel="noopener" color="textPrimary">
                    {data.EquipamentoByID[0].URL}
                  </Link>
                </Typography>
              </div>
            </>
          )}

          {data.EquipamentoByID[0].EMAIL && (
            <div className={classes.section}>
              <Typography
                className={classes.subtitle}
                color={"primary"}
              >
                Email
              </Typography>
              <Typography color="textPrimary" >
                {data.EquipamentoByID[0].EMAIL}
              </Typography>
            </div>
          )}

          {data.EquipamentoByID[0].DistritoNome && (
            <div className={classes.section}>
              <Typography
                className={classes.subtitle}
                color={"primary"}
              >
                Distrito
              </Typography>
              <Typography color="textPrimary" >
                {data.EquipamentoByID[0].DistritoNome}
              </Typography>
            </div>
          )}
          
          <div className={classes.section}>
            <Typography
              className={classes.subtitle}
              color={"primary"}
            >
              Localização
            </Typography>
            <Typography color="textPrimary">
              {data.EquipamentoByID[0].Endereco}
            </Typography>
            <iframe
              title="mapa"
              className={classes.map}
              loading="lazy"
              src={`https://www.google.com/maps/embed/v1/place?q=${data.EquipamentoByID[0].Endereco}&key=${process.env.REACT_APP_MAPS_KEY}`}
            >
            </iframe>
          </div>
        </div>
      </PageContainer>
      <div className={classes.waveBottom}>
        <img src={setWaveColor(redeId)} alt="onda"/>
      </div>
      <BottomBar/>
    </>
  );
}

export default Equipment;
